import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/User.svg'
import _imports_1 from '../assets/images/LogOut.svg'


const _withScopeId = n => (_pushScopeId("data-v-3c15cbad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex content-center flex-col items-center justify-center text-sm p-5 br16" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_3 = { class: "mr-2 profileIcon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mr-2" }
const _hoisted_6 = { class: "mr-2" }
const _hoisted_7 = { class: "mr-2" }
const _hoisted_8 = { class: "mr-2" }
const _hoisted_9 = { class: "mr-2" }
const _hoisted_10 = { class: "mr-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-2 profileIcon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgContainer = _resolveComponent("SvgContainer")!
  const _component_Onboarding = _resolveComponent("Onboarding")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goUser && _ctx.goUser(...args))),
      class: "items-center cursor-pointer flex p-2 w-60 xxsm:w-36 m-center"
    }, [
      _hoisted_2,
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("my_profile")), 1)
    ]),
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goMatches && _ctx.goMatches(...args))),
      class: "items-center cursor-pointer flex p-2 w-60 xxsm:w-36 m-center"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", { src: _ctx.matchIconSelected }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("my_matches")), 1)
    ]),
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goPays && _ctx.goPays(...args))),
      class: "items-center cursor-pointer flex p-2 w-60 xxsm:w-36 m-center"
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_SvgContainer, { name: "myPayIcon" })
      ]),
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("my_payments")), 1)
    ]),
    _createElementVNode("div", {
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showOnBoarding && _ctx.showOnBoarding(...args))),
      class: "items-center cursor-pointer flex p-2 w-60 xxsm:w-36 m-center"
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_SvgContainer, { name: "normalCircleIcon" })
      ]),
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("my_preferences")), 1)
    ]),
    _createElementVNode("div", {
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goLikes && _ctx.goLikes(...args))),
      class: "items-center cursor-pointer flex p-2 w-60 xxsm:w-36 m-center"
    }, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_SvgContainer, { name: "myFavIcon" })
      ]),
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("my_favorites")), 1)
    ]),
    _createElementVNode("div", {
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goPrivacy && _ctx.goPrivacy(...args))),
      class: "items-center cursor-pointer flex p-2 w-60 xxsm:w-36 m-center"
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_SvgContainer, { name: "circleIcon" })
      ]),
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("my_privacy")), 1)
    ]),
    _createElementVNode("div", {
      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goClubs && _ctx.goClubs(...args))),
      class: "items-center cursor-pointer flex p-2 w-60 xxsm:w-36 m-center"
    }, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_SvgContainer, { name: "myClubIcon" })
      ]),
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("my_linked_clubs")), 1)
    ]),
    _createElementVNode("div", {
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push('/remove-account'))),
      class: "items-center cursor-pointer flex p-2 w-60 xxsm:w-36 m-center"
    }, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_SvgContainer, { name: "circleIcon" })
      ]),
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("remove_account")), 1)
    ]),
    _createElementVNode("div", {
      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
      class: "items-center cursor-pointer flex p-2 w-60 xxsm:w-36 m-center"
    }, [
      _hoisted_11,
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("logout")), 1)
    ]),
    _createVNode(_component_Onboarding, { onRefresh: _ctx.handleRefresh }, null, 8, ["onRefresh"])
  ]))
}